import dayjs from 'dayjs';
import React, { FC, useEffect, useState } from 'react';
import QrReader from 'react-qr-reader';
import { Link } from 'react-router-dom';
import Alert from '../../components/alerts/Alert';
import {
  fetchOrder,
  fetchOrdersBundles,
  fetchOrderScans,
} from '../../fetch/orderFetch';
import { OrderClazz, ParcelScan } from '../../types/orderTypes';
import { OrderBundle } from '../oldPlanner/utils/bundleDraft';
import './InfoScanner.scss';
import { Helmet } from 'react-helmet';

const InfoScanner: FC = () => {
  const [orderId, setOrderId] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [order, setOrder] = useState<OrderClazz>(null);
  const [bundle, setBundle] = useState<OrderBundle>(null);
  const [scans, setScans] = useState<ParcelScan[]>([]);

  const [tmpOrder, setTmpOrders] = useState<string>('');

  useEffect(() => {
    const getOrderData = async () => {
      const orderData = await fetchOrder(orderId);
      const scansData = await fetchOrderScans(orderId);
      const bundleData = await fetchOrdersBundles([orderId]);

      setOrder(orderData);
      setScans(scansData);
      setBundle(bundleData[0]);
    };

    if (orderId) {
      getOrderData();
    }
  }, [orderId, setError]);

  const handleScan = (data: any) => {
    setError('');
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        setOrderId(parsedData.orderId);
      } catch (e) {
        setError("Not valid QR code. Can't scan package");
        console.error(e);
      }
    }
  };
  return (
    <div className="infoScanner">
      <Helmet>
        <title>Info Scanner</title>
      </Helmet>
      <div className="content">
        <QrReader
          delay={300}
          onError={() => {}}
          onScan={handleScan}
          style={{ width: '100%' }}
        />
        <div className={`inputArea${order ? '' : ' borderRadius'}`}>
          <input
            onChange={e => setTmpOrders(e.target.value)}
            value={tmpOrder}
            placeholder="Order id"
            type="tel"
          />
          <button
            onClick={() => {
              setOrderId(tmpOrder);
              setTmpOrders('');
            }}
          >
            Find
          </button>
        </div>
        {order && (
          <div className="infoView">
            <div className="orderBundleInfo">
              <Link to={`/orders/${order.id}`}>{order.id}</Link>
              <span
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                }}
              >
                <span>
                  {bundle && bundle.bundle?.id}{' '}
                  {bundle && bundle.bundle?.shelfId}
                </span>
                {order.courierName && (
                  <span style={{ fontWeight: 300, fontSize: 12 }}>
                    {order.courierName}
                  </span>
                )}
              </span>
            </div>
            <div className="recipient">
              <span className="labelText">Sender</span>
              <span>{order.pickupName}</span>
            </div>
            <div className="recipient">
              <span className="labelText">Recipient</span>
              <span>{order.recipientName}</span>
              <a href={`tel:${order.recipientPhone}`}>{order.recipientPhone}</a>
              <span>{order.destinationAddress.fullAddressString}</span>
            </div>
            {scans && (
              <div className="scans">
                <span className="labelText">Scans</span>
                <table>
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Scan time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {scans.map(scan => (
                      <tr key={scan.scannedAt}>
                        <td>{scan.scanType}</td>
                        <td>
                          {dayjs(scan.scannedAt).format('DD.MM.YYYY HH:mm:ss')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className="note">
              <span className="labelText">Note</span>
              <span>{order.noteForCourier}</span>
            </div>
          </div>
        )}
        {error && <Alert type="danger">{error}</Alert>}
      </div>
    </div>
  );
};

export default InfoScanner;
